module.exports = require('./convert')(
  ".exportsfunc\"#$&',/:;<>?@[\\]^`abdghijklmqvwyz{|}~",
  "юучзщкеіагтсЄ№;?єб.ЖжБЮ,\"хґї:'фивпршолдьймцняХҐЇʼ"
)
